import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme, loading }) => css`
    background-color: ${loading && theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-family: ${theme.v2.font.family.primary};
    gap: 16px;
    height: ${loading && 'calc(100vh - 80px)'};
    min-height: calc(100vh - 80px);
    margin: 0 24px 16px 24px;
    align-content: flex-start;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;
    }
  `}
`;
